// extracted by extract-css-chunks-webpack-plugin
module.exports = {"agreements-wrapper":"account__agreements-wrapper--16OZK","agreementsWrapper":"account__agreements-wrapper--16OZK"};